import {Injectable, inject} from '@angular/core'
import {EmbeddedStoreService} from '@service/embeddingService/embedded-store.service'
import {ActionService} from './action.service'

/**
 * Variante embebida de `ActionService`.
 *
 * @description
 * En modo embebido las acciones son las que el host envía a través del payload (lista
 * única, normalmente una única acción "pedido"). La precarga se limita a leer el signal
 * `actions` de `EmbeddedStoreService` — no hay acceso a PouchDB.
 */
@Injectable({
  providedIn: 'root',
})
export class ActionEmbeddedService extends ActionService {
  private readonly embeddedStoreService: EmbeddedStoreService = inject(EmbeddedStoreService)
  override preloadActions = async (): Promise<void> => {
    this.actions = this.embeddedStoreService.actions()
  }
}
